import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import Title from "../Title";

function SoundSketchPrivacy() {
  document.title = "SoundSketch プライバシーポリシー | 株式会社PO";

  return (
    <div id="privacyPage">
      <Header />
      <div className="contents_inner">
        <Title>Privacy Policy</Title>

        <div className="layout">
          <div className="postBox">
            <div className="postWrap" style={{ display: "block" }}>
              <article className="privacyArticle">
                <h2>SoundSketch プライバシーポリシー</h2>
                <p>制定日：2026年7月15日</p>
                <p>運営者：株式会社PO</p>

                <h3>1. 取得する情報</h3>
                <p>
                  本アプリは、ユーザーの演奏操作、作成したプロジェクト、
                  音符、テンポ、音色、その他の設定情報を、
                  音楽制作機能を提供するために利用します。
                </p>

                <h3>2. 個人情報の収集について</h3>
                <p>
                  本アプリは、氏名、メールアドレス、電話番号、位置情報、
                  連絡先等の個人情報を収集しません。
                </p>

                <h3>3. 端末内データの扱い</h3>
                <p>
                  本アプリで作成したプロジェクトおよび設定情報は、
                  原則としてユーザーの端末内に保存されます。
                  当社の外部サーバーへ送信することはありません。
                  アプリを削除した場合、端末内に保存されたデータが削除されることがあります。
                </p>

                <h3>4. MIDI・オーディオファイルの書き出しについて</h3>
                <p>
                  本アプリでは、作成したデータをMIDIファイルまたは
                  オーディオファイルとして書き出し、
                  ユーザー自身の操作により他のアプリやサービスへ共有できる場合があります。
                  共有先における情報の取扱いについては、
                  各アプリまたはサービスのプライバシーポリシーが適用されます。
                </p>

                <h3>5. マイク・録音機能について</h3>
                <p>
                  本アプリは、端末のマイクを使用してユーザーの音声を
                  録音、保存、送信する機能を提供しません。
                  オーディオファイルは、アプリ内の演奏データをもとに生成されます。
                </p>

                <h3>6. アプリ内購入について</h3>
                <p>
                  本アプリでは、追加音源等の機能を提供するために、
                  App Storeのアプリ内購入を使用します。
                  購入処理はAppleが提供する仕組みにより行われ、
                  当社がクレジットカード番号等の支払い情報を取得、
                  保存することはありません。
                  購入状態は、購入済み機能を有効化または復元する目的でのみ確認されます。
                </p>

                <h3>7. 広告・解析ツールについて</h3>
                <p>
                  本アプリは、広告配信SDKおよびアクセス解析ツールを使用しません。
                </p>

                <h3>8. 第三者提供</h3>
                <p>
                  本アプリは、取得した情報を第三者に提供することはありません。
                  ただし、ユーザー自身が書き出しまたは共有機能を利用した場合を除きます。
                </p>

                <h3>9. お問い合わせ</h3>
                <p>
                  本ポリシーに関するお問い合わせは以下までお願いいたします。
                  <br />
                  株式会社PO
                  <br />
                  <a href="/#contact" className="link">
                    お問い合わせフォームはこちら
                  </a>
                </p>

                <h3>10. 改定</h3>
                <p>
                  本ポリシーは必要に応じて改定されることがあります。
                  改定後は本ページにて告知します。
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SoundSketchPrivacy;
